export default {
  imgSrc: '/jyz/file/showImage?fileId=',
  fileSrc: '/jyz/file/download?fileId=',
  getUserData() {
    if (!localStorage.userData) {
      return false;
    } else {
      return true;
    }
  },
  cutLine(str) {
    console.log(str);
  },
  IsInArray(arr, val) {
    var testStr = ',' + arr.join(",") + ",";
    return testStr.indexOf("," + val + ",") != -1;
  },
  token:'',
  userId:'',
  userName:'',
  roles:'',
  phone:'',
  userType:'',
  boxId:'',
  boxArray:'',
  stockId:'',
  stockArray:'',
}

export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  alert('xx')
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) z
  document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export function getFormatOnlyDate(time) {

  var date = new Date(time);
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

export function base64decode(str) {
  var c1, c2, c3, c4;
  var i, len, out;
  var base64DecodeChars = new Array(
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
    52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1,
    -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
    15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1,
    -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
  len = str.length;
  i = 0;
  out = "";
  while (i < len) {
    /* c1 */
    do {
      c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c1 == -1);
    if (c1 == -1)
      break;

    /* c2 */
    do {
      c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c2 == -1);
    if (c2 == -1)
      break;

    out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

    /* c3 */
    do {
      c3 = str.charCodeAt(i++) & 0xff;
      if (c3 == 61)
        return out;
      c3 = base64DecodeChars[c3];
    } while (i < len && c3 == -1);
    if (c3 == -1)
      break;

    out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

    /* c4 */
    do {
      c4 = str.charCodeAt(i++) & 0xff;
      if (c4 == 61)
        return out;
      c4 = base64DecodeChars[c4];
    } while (i < len && c4 == -1);
    if (c4 == -1)
      break;
    out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
  }
  return out;
}

/*
 格式化时间
 */

export function getFormatDate(time) {
  var date = new Date(time);
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var seconds = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hour >= 0 && hour <= 9) {
    hour = "0" + hour;
  }
  if (minute >= 0 && minute <= 9) {
    minute = "0" + minute;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
    + " " + hour + seperator2 + minute
    + seperator2 + seconds;
  return currentdate;
}

export function getWeekTime(year, month, week) {
  // 变量第几周

  // 一天时间的毫秒时长
  var daySeconds = 24 * 3600 * 1000;
  // 指定年份第一天的日期对象，即：一月一日
  var firstDayOfYear = new Date(year + '/' + month + '/01');
  /**
   * 计算第一周的第一天日期对象
   * 通过当年的第一天取得是星期几，用当年的第一天减去第一周已经过去的几天，得到第一周的第一天
   */
  var firstDayOfFirstWeek = new Date(firstDayOfYear.getTime() - firstDayOfYear.getDay() * daySeconds);
  /**
   * 计算指定第week周的第一天
   * week-1：第week周，区间应该是第（week - 1）周结束后开始算起
   * 7：一周有7天
   */
  var firstDayOfThisWeek = new Date(firstDayOfFirstWeek.getTime() + (week - 1) * 7 * daySeconds);
  /**
   * 计算指定第week周的最后一天
   * 6：一周共7天，开始那一天加上6天得到最后一天
   */
  var lastDayOfThisWeek = new Date(firstDayOfThisWeek.getTime() + 6 * daySeconds);
  var monthFirst = firstDayOfThisWeek.getMonth() + 1;
  var monthEnd = lastDayOfThisWeek.getMonth() + 1;
  var startDayStr = firstDayOfThisWeek.getFullYear() + '-' + (firstDayOfThisWeek.getMonth() + 1) + '-' + (firstDayOfThisWeek.getDate() + 1);
  var endDayStr = lastDayOfThisWeek.getFullYear() + '-' + (lastDayOfThisWeek.getMonth() + 1) + '-' + (lastDayOfThisWeek.getDate() + 1);
  var db = new Date();
  db.setUTCFullYear(firstDayOfThisWeek.getFullYear(), firstDayOfThisWeek.getMonth(), firstDayOfThisWeek.getDate() + 1);
  var de = new Date();
  de.setUTCFullYear(lastDayOfThisWeek.getFullYear(), lastDayOfThisWeek.getMonth(), lastDayOfThisWeek.getDate() + 1);
  var unixDb = db.getTime();
  var unixDe = de.getTime();
  var dateArray = [];
  for (var k = unixDb; k <= unixDe;) {
    var newDate = new Date(parseInt(k));

    var s = '';
    var newmouth = (newDate.getMonth() + 1) >= 10 ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1));
    var day = newDate.getDate() >= 10 ? newDate.getDate() : ('0' + newDate.getDate());
    s += newDate.getFullYear() + '-'; // 获取年份。
    s += newmouth + "-"; // 获取月份。
    s += day; // 获取日。
    k = k + 24 * 60 * 60 * 1000;
    var data = {date: s, type: 0, month: newmouth, day: day}
    if (newmouth != month) {
      data.type = 1;
    }
    dateArray.push(data)
  }
  console.log(JSON.stringify(dateArray));
  return dateArray


}

export function confirmDialog(self, title, content, cb) {
  self.$Modal.confirm({
    title: title,
    content: content,
    onOk: () => {
      cb(self)
      //this.$Message.info('Clicked ok');
    },
    onCancel: () => {
      //this.$Message.info('Clicked cancel');
    }
  });
}

export function getFormatDate2(start, end) {

  var statrDate = new Date(start);
  var endDate = new Date(end);

  var month = statrDate.getMonth() + 1;
  var strDate = statrDate.getDate();
  var starthour = statrDate.getHours();
  var statrminute = statrDate.getMinutes();
  var endHour = endDate.getHours();
  var endMinute = endDate.getMinutes();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (starthour >= 1 && starthour <= 9) {
    starthour = "0" + starthour;
  }
  if (statrminute >= 0 && statrminute <= 9) {
    statrminute = "0" + statrminute;
  }
  if (endHour >= 0 && endHour <= 9) {
    endHour = "0" + endHour;
  }
  if (endMinute >= 0 && endMinute <= 9) {
    endMinute = "0" + endMinute;
  }
  var dateDetial = {};
  dateDetial.year = statrDate.getFullYear();
  dateDetial.monthDate = month + '/' + strDate;
  dateDetial.startTime = starthour + ':' + statrminute;
  dateDetial.endTime = endHour + ':' + endMinute;
  return dateDetial;


}

export function validatemobile(mobile) {
  if (mobile.length != 11) {
    return false;
  }

  var partten = /^1[3|4|5|6|7|8][0-9]{9}$/;
  if (!partten.test(mobile)) {
    //alert(mobile)
    //console.log(mobile)
    return false;
  }
  return true;
}

export function jsonToGet(sstr) {

  sstr = sstr.replace(/\t/g, "");

  sstr = sstr.replace(/\"/g, "").replace("{", "").replace("}", "")
  sstr = sstr.replace(",", "&").replace(":", "=");
  sstr = sstr.replace(/\"/g, "").replace(/{/g, "").replace(/}/g, "")
  sstr = sstr.replace(/,/g, "&").replace(/:/g, "=");
  return sstr;
}

export function getToJson(sstr) {
  sstr = sstr.replace(/&/g, '","').replace(/=/g, '":"');
  sstr = '{"' + sstr + '"}';
  return sstr;
};

export function linkScriptDOMLoaded(url) {


  var doc = document;
  var link = doc.createElement("link");
  link.setAttribute("rel", "stylesheet");
  link.setAttribute("type", "text/css");
  link.setAttribute("href", url);

  var heads = doc.getElementsByTagName("head");
  if (heads.length)
    heads[0].appendChild(link);
  else
    doc.documentElement.appendChild(link);
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}



// WEBPACK FOOTER //
// ./src/util.js